module.exports = __webpack_public_path__ + "img/20191223132610360截图20191223125436855.94b2b6c9.jpg";